import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const maxtHist = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_MaxTempJuly/MapServer/12",
    title: 'Max Temp July Historical',
    opacity: 0.4,
    oraId: 'maxtHist',
  })